{
  "language": {
    "title": "Wybierz język",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Witamy, jak możemy Ci pomóc?",
    "checkIn": "Zameldowanie",
    "independentManualCheckIn": "Bez rezerwacji",
    "integratedManualCheckIn": "Zamelduj się ręcznie",
    "checkOut": "Wymeldowanie",
    "manualCheckOut": "Wymelduj się ręcznie",
    "parcelDelivery": "Dostawa przesyłek",
    "foodDelivery": "Dostawa jedzenia",
    "callReception": "Zadzwoń do recepcji",
    "overview": "Przegląd",
    "unavailable": "Recepcja jest obecnie niedostępna."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Wybierz opcję zameldowania",
        "manual": "Zamelduj się ręcznie",
        "code": "Zamelduj się kodem PIN lub kodem QR",
        "code-no-qr": "Zamelduj się kodem PIN"
      },
      "checkout": {
        "title": "Wybierz opcję wymeldowania",
        "manual": "Wymelduj się podając imię",
        "code": "Wymelduj się kodem PIN lub kodem QR",
        "code-no-qr": "Wymelduj się kodem PIN"
      }
    },
    "title": "Możesz teraz zeskanować kod QR lub wpisać kod PIN.",
    "orText": "Lub",
    "qrScanner": {
      "checkin": {
        "title": "Wybierz opcję zameldowania"
      },
      "checkout": {
        "title": "Wybierz opcję wymeldowania"
      },
      "btn": "Zeskanuj kod QR"
    },
    "hidScanner": {
      "title": "Przyłóż kod QR do skanera poniżej lub wprowadź swój kod PIN"
    },
    "pinOnly": {
      "title": "Wprowadź swój kod PIN"
    },
    "pinCode": "Wpisz kod PIN",
    "manually": {
      "checkin": "Nie masz kodu do zameldowania?"
    },
    "status": {
      "idle": {
        "title": "Kod jest skanowany.",
        "message": "Proszę czekać...",
        "nfc": {
          "title": "Twój tag jest skanowany.",
          "message": "Proszę czekać..."
        }
      },
      "loading": {
        "title": "Kod jest skanowany.",
        "message": "Proszę czekać...",
        "nfc": {
          "title": "Twój tag jest skanowany.",
          "message": "Proszę czekać..."
        }
      },
      "error": {
        "title": "Twój kod jest nieprawidłowy.",
        "message": "Spróbuj ponownie!",
        "nfc": {
          "title": "Twój tag jest nieprawidłowy.",
          "message": "Spróbuj ponownie!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Trochę za wcześnie",
            "message": "Twój kod jest ważny od {{validFromTime}}. Spotkanie zaczyna się o {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Ten kod wygasł",
            "message": "Spotkanie zakończyło się o {{meetingEndTime}}. Twój kod był ważny do {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Pomyślnie się zameldowałeś.",
            "message": "Dziękujemy."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Pomyślnie się zameldowałeś.",
              "message": "Dziękujemy."
            },
            "email-sms": {
              "title": "Pomyślnie się zameldowałeś.",
              "message": "Twoja osoba kontaktowa została powiadomiona."
            },
            "call-ping": {
              "title": "Pomyślnie się zameldowałeś.",
              "message": "Teraz połączymy Cię telefonicznie z osobą kontaktową."
            },
            "teams-call": {
              "title": "Pomyślnie się zameldowałeś.",
              "message": "Teraz nawiążemy połączenie Microsoft Teams z osobą kontaktową."
            },
            "badge": {
              "title": "Dziękujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.",
              "message": ""
            },
            "video-call": {
              "title": "Pomyślnie się zameldowałeś.",
              "message": "Trwa konfigurowanie połączenia wideo z osobą kontaktową."
            }
          },
          "Employee": {
            "title": "Pomyślnie się zameldowałeś.",
            "message": "Dziękujemy.",
            "badge": {
              "title": "Dziękujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Pomyślnie się zameldowałeś.",
            "message": "Dziękujemy.",
            "badge": {
              "title": "Dziękujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Pomyślnie się wymeldowałeś.<br/>",
            "message": "Do zobaczenia wkrótce."
          },
          "MeetingAttendee": {
            "title": "Pomyślnie się wymeldowałeś.",
            "message": "Do zobaczenia wkrótce."
          },
          "Employee": {
            "title": "Pomyślnie się wymeldowałeś.",
            "message": "Do zobaczenia wkrótce."
          },
          "Visitor": {
            "title": "Pomyślnie się wymeldowałeś.",
            "message": "Do zobaczenia wkrótce."
          },
          "access": {
            "title": "Pomyślnie się wymeldowałeś.",
            "message": "Możesz teraz otworzyć drzwi."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Jeszcze kilka informacji przed zameldowaniem",
    "subtitle": "Pola oznaczone * są wymagane",
    "btn": "Zamelduj się",
    "placeholder": {
      "other": "Inne...",
      "otherInput": "Wpisz swoją opcję"
    },
    "error": {
      "required": "Nie wypełniono tego pola",
      "email": "Nieprawidłowy adres e-mail",
      "phone": "Nieprawidłowy numer telefonu"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Proszę wypełnić.",
      "documentScanner": "Zwróć uwagę podczas wkładania dokumentu tożsamości:"
    },
    "subtitle": {
      "default": "Uwaga - każde pole * jest wymagane",
      "documentScanner": [
        {
          "parts": [
            { "text": "Strona z ", "bold": false },
            { "text": "znakami <<< >>> (MRZ) ", "bold": true },
            { "text": "musi być ", "bold": false },
            { "text": "skierowana w stronę kiosku / skanera.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Trzymaj kartę nieruchomo ", "bold": false },
            {
              "text": "aż pola zostaną wypełnione automatycznie.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Brak opcji",
    "btn": "Zamelduj się",
    "placeholder": {
      "name": "Twoje imię i nazwisko *",
      "email": "Twój e-mail *",
      "phone": "Numer telefonu",
      "contactName": "Twoja osoba kontaktowa*",
      "other": "Inne..."
    },
    "error": {
      "required": "Nie wypełniłeś tego pola",
      "name": "Nieprawidłowe imię",
      "email": "Nieprawidłowy adres e-mail",
      "phone": "Nieprawidłowy numer telefonu"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Proszę czekać...",
          "message": "Twoja rejestracja jest przetwarzana."
        },
        "contact": {
          "title": "Proszę czekać...",
          "message": "Twoja osoba kontaktowa jest powiadamiana."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Proszę czekać...",
          "message": "Twoja rejestracja jest przetwarzana."
        },
        "contact": {
          "title": "Proszę czekać...",
          "message": "Twoja osoba kontaktowa jest powiadamiana."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Pomyślnie się zameldowałeś.",
          "message": "Dziękujemy."
        },
        "email-sms": {
          "title": "Pomyślnie się zameldowałeś.",
          "message": "Twoja osoba kontaktowa została powiadomiona."
        },
        "call-ping": {
          "title": "Pomyślnie się zameldowałeś.",
          "message": "Teraz nawiążemy połączenie telefoniczne z osobą kontaktową."
        },
        "teams-call": {
          "title": "Pomyślnie się zameldowałeś.",
          "message": "Teraz nawiążemy połączenie Microsoft Teams z osobą kontaktową"
        },
        "badge": {
          "title": "Dziękujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.",
          "message": ""
        },
        "video-call": {
          "title": "Pomyślnie się zameldowałeś.",
          "message": "Trwa konfigurowanie połączenia wideo z osobą kontaktową."
        }
      },
      "error": {
        "title": "Coś poszło nie tak.",
        "message": "Spróbuj ponownie!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Dokument nieważny",
        "message": "Dokument nie mógł zostać zweryfikowany lub stracił ważność. Proszę wprowadzić dane ręcznie."
      }
    }
  },
  "manualCheckout": {
    "title": "Wpisz swoje imię, aby się wymeldować",
    "btn": "Wymelduj się",
    "form": {
      "placeholder": {
        "name": "Twoje imię i nazwisko *"
      },
      "loading": "Ładowanie...",
      "noOptions": "Brak opcji"
    },
    "error": {
      "required": "Nie wypełniłeś tego pola",
      "name": "Nieprawidłowe imię"
    },
    "status": {
      "idle": {
        "title": "Przetwarzamy Twoje informacje.",
        "message": "Proszę czekać..."
      },
      "loading": {
        "title": "Przetwarzamy Twoje informacje.",
        "message": "Proszę czekać..."
      },
      "success": {
        "title": "Pomyślnie się wymeldowałeś.",
        "message": "Dziękujemy i miłego dnia."
      },
      "successAccess": {
        "title": "Pomyślnie się wymeldowałeś.",
        "message": "Teraz możesz otworzyć drzwi."
      },
      "error": {
        "title": "Wystąpił błąd podczas wymeldowania.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Czy chcesz powiadomić swoją osobę kontaktową?",
      "email-sms": "Wysłaliśmy e-mail/SMS do Twojej osoby kontaktowej.<br/>Czy chcesz dodatkowo nawiązać z nią połączenie?"
    },
    "callBtn": "Zadzwoń",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Rozmowa wideo",
    "teamsCallBtn": "Rozmowa Teams",
    "teamsMessageBtn": "Wiadomość Teams",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Anuluj",
    "cancelBtn": "Anuluj połączenie",
    "status": {
      "connecting": {
        "title": "Nawiązywanie połączenia.<br/>Proszę czekać...",
        "message": ""
      },
      "ringing": {
        "title": "Dzwonimy do Twojej osoby kontaktowej<br/>Proszę czekać...",
        "message": ""
      },
      "ringingReception": {
        "title": "Rozpoczęto połączenie...",
        "message": ""
      },
      "open": {
        "title": "Połączenie w toku.",
        "message": ""
      },
      "close": {
        "title": "Połączenie zakończone.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Połączenie zakończone.<br/>Teraz możesz otworzyć drzwi.",
        "message": ""
      },
      "closeReception": {
        "title": "Połączenie zostało zakończone.",
        "message": ""
      },
      "error": {
        "title": "Połączenie nie zostało nawiązane.<br/>Spróbować ponownie?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "loading": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "success": {
        "title": "SMS został wysłany. Osoba kontaktowa została powiadomiona.",
        "message": "Dziękujemy!"
      },
      "successAccess": {
        "title": "SMS został wysłany. Osoba kontaktowa została powiadomiona.",
        "message": "Teraz możesz otworzyć drzwi."
      },
      "error": {
        "title": "SMS nie został wysłany.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "videoCall": {
    "title": "Rozmowa wideo",
    "endCall": "Zakończ rozmowę",
    "status": {
      "idle": {
        "title": "Tworzymy pokój wideo.",
        "message": "Proszę czekać..."
      },
      "loading": {
        "title": "Tworzymy pokój wideo.",
        "message": "Proszę czekać..."
      },
      "success": {
        "title": "Pokój wideo został pomyślnie utworzony.",
        "message": "Dołączanie do pokoju..."
      },
      "error": {
        "title": "Pokój wideo nie został pomyślnie utworzony.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "teamsCall": {
    "title": "Rozmowa Teams",
    "controls": {
      "startCall": "Rozpocznij rozmowę",
      "endCall": "Opuść",
      "camera": "Kamera",
      "cameraOff": "Kamera wyłączona",
      "mic": "Mikrofon",
      "micOff": "Mikrofon wyłączony",
      "ringing": "Dzwonienie...",
      "noAnswer": "Nikt nie odpowiedział na połączenie."
    },
    "status": {
      "connecting": {
        "title": "Nawiązywanie połączenia.<br/>Proszę czekać...",
        "message": ""
      },
      "ringing": {
        "title": "Dzwonimy do Twojej osoby kontaktowej<br/>Proszę czekać...",
        "message": ""
      },
      "connected": {
        "title": "Nawiązywanie połączenia",
        "message": ""
      },
      "disconnected": {
        "title": "Połączenie zakończone.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Połączenie zakończone.<br/>Teraz możesz otworzyć drzwi.",
        "message": ""
      },
      "error": {
        "title": "Połączenie nie zostało nawiązane.<br/>Spróbuj ponownie",
        "message": ""
      },
      "noAnswer": {
        "title": "Nikt nie odpowiedział na połączenie.<br/>Spróbuj ponownie.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "loading": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "success": {
        "title": "Wiadomość została wysłana. Osoba kontaktowa została powiadomiona.",
        "message": "Dziękujemy!"
      },
      "successAccess": {
        "title": "Wiadomość została wysłana. Osoba kontaktowa została powiadomiona.",
        "message": "Teraz możesz otworzyć drzwi."
      },
      "error": {
        "title": "Wiadomość nie została wysłana.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "loading": {
        "title": "Powiadamiamy Twoją osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "success": {
        "title": "Wiadomość została wysłana. Osoba kontaktowa została powiadomiona.",
        "message": "Dziękujemy!"
      },
      "successAccess": {
        "title": "Wiadomość została wysłana. Osoba kontaktowa została powiadomiona.",
        "message": "Teraz możesz otworzyć drzwi."
      },
      "error": {
        "title": "Wiadomość nie została wysłana.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "packageDelivery": {
    "title": "Jak miło z Twojej strony, że dostarczasz przesyłkę!",
    "subtitle": "Wybierz i powiadom odbiorcę",
    "subtitle1": "Naciśnij przycisk poniżej, aby dać nam znać, że jesteś tutaj!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Dla kogo jest przesyłka"
      },
      "error": {
        "contact": {
          "required": "Nie wypełniłeś tego pola"
        }
      }
    },
    "button": {
      "submit": "Powiadom"
    },
    "status": {
      "loading": {
        "title": "Powiadamiamy osobę kontaktową.",
        "message": "Proszę czekać..."
      },
      "success": {
        "no-email-sms": {
          "title": "Dziękujemy za dostawę!",
          "message": ""
        },
        "email-sms": {
          "title": "Osoba kontaktowa została powiadomiona.",
          "message": "Dziękujemy za dostawę!"
        },
        "call-ping": {
          "title": "Dziękujemy za dostawę!",
          "message": "Teraz zostanie nawiązane połączenie telefoniczne z osobą kontaktową."
        },
        "teams-call": {
          "title": "Dziękujemy za dostawę!",
          "message": "Teraz zostanie nawiązane połączenie Microsoft Teams z osobą kontaktową."
        },
        "video-call": {
          "title": "Dziękujemy za dostawę!",
          "message": "Trwa konfigurowanie połączenia wideo z osobą kontaktową."
        }
      },
      "error": {
        "title": "Coś poszło nie tak.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "foodDelivery": {
    "title": "Jak miło z Twojej strony, że dostarczasz jedzenie!",
    "subtitle": "Wybierz i powiadom odbiorcę",
    "subtitle1": "Naciśnij przycisk poniżej, aby dać nam znać, że jesteś tutaj!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Dla kogo jest jedzenie"
      },
      "error": {
        "contact": {
          "required": "Nie wypełniłeś tego pola"
        }
      }
    },
    "button": {
      "submit": "Powiadom"
    },
    "status": {
      "loading": {
        "title": "Powiadamiamy osobę kontaktową.",
        "message": "Proszę czekać!"
      },
      "success": {
        "no-email-sms": {
          "title": "Dziękujemy za dostawę!",
          "message": ""
        },
        "email-sms": {
          "title": "Osoba kontaktowa została powiadomiona.",
          "message": "Dziękujemy za dostawę!"
        },
        "call-ping": {
          "title": "Dziękujemy za dostawę!",
          "message": "Teraz zostanie nawiązane połączenie telefoniczne z osobą kontaktową."
        },
        "teams-call": {
          "title": "Dziękujemy za dostawę!",
          "message": "Teraz zostanie nawiązane połączenie Microsoft Teams z osobą kontaktową."
        },
        "video-call": {
          "title": "Dziękujemy za dostawę!",
          "message": "Trwa konfigurowanie połączenia wideo z osobą kontaktową."
        }
      },
      "error": {
        "title": "Coś poszło nie tak.",
        "message": "Spróbuj ponownie!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Proszę zeskanować kod QR",
    "subtitle": "Ustaw kod QR wewnątrz czerwonych rogów i trzymaj telefon stabilnie.",
    "error": "Nieprawidłowy format kodu QR",
    "unknownError": "Wystąpił nieznany błąd podczas skanowania"
  },
  "common": {
    "backBtn": "Wstecz"
  },
  "previewPDF": {
    "page": {
      "of": "z",
      "previous": "Poprzednia",
      "next": "Następna"
    },
    "button": {
      "cancel": "Anuluj",
      "accept": "Akceptuj",
      "next": "Następny"
    },
    "title": {
      "consent": "Wymagana zgoda"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "Recepcja cyfrowa jest obecnie offline i nie może być używana, należy sprawdzić połączenie internetowe!",
    "check": "Jesteś gościem i chcesz porozmawiać bezpośrednio z pracownikiem? Zadzwoń pod numer {{receptionistPhone}}"
  },
  "overview": {
    "title": "Wprowadź kod, aby otworzyć przegląd!",
    "noUsers": "Brak rejestracji",
    "status": {
      "success": {
        "title": "Kod jest prawidłowy.",
        "message": ""
      },
      "error": {
        "title": "Kod nieprawidłowy.",
        "message": "Spróbuj ponownie!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Proszę czekać...",
        "message": ""
      },
      "success": {
        "title": "Pomyślne wymeldowanie.",
        "message": ""
      },
      "error": {
        "title": "Coś poszło nie tak.",
        "message": "Spróbuj ponownie!"
      }
    },
    "listTitle": "Lista osób, które zameldowały się dzisiaj, ale się nie wymeldowały",
    "page": "Strona ",
    "table": {
      "head": {
        "fullName": "Imię i nazwisko",
        "type": "Typ",
        "checkedinAt": "Zameldowany o",
        "host": "Gospodarz"
      },
      "type": {
        "Package": "Dostawa przesyłek",
        "Food": "Dostawa jedzenia",
        "Visitor": "Gość",
        "MeetingAttendee": "Zaproszony gość",
        "Employee": "Pracownik",
        "Guest": "Gość"
      }
    },
    "confirmModal": {
      "title": "Czy na pewno chcesz wymeldować {{fullName}}?",
      "cancel": "Anuluj",
      "checkout": "Wymelduj"
    }
  },
  "wifi": {
    "title": "Połącz z siecią Wi-Fi"
  },
  "door": {
    "external": {
      "title": "Otwieranie drzwi",
      "subtitle": "Drzwi otworzą się wkrótce. Proszę czekać..."
    },
    "control": {
      "title": "Możesz teraz otworzyć drzwi",
      "subtitle": "Proszę nacisnąć przycisk poniżej!",
      "openBtn": "Otwórz drzwi"
    },
    "status": {
      "success": {
        "title": "Drzwi zostały otwarte",
        "message": ""
      },
      "error": {
        "title": "Coś poszło nie tak",
        "message": "Skontaktuj się z osobą kontaktową, aby otworzyć drzwi."
      },
      "loading": {
        "title": "Otwieranie drzwi...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Czy chciałbyś zrobić zdjęcie w ramach procesu zameldowania?",
    "required": {
      "title": "Wymagana weryfikacja zdjęciowa!",
      "instructions": "Proszę stanąć przed kamerą i postępować zgodnie z instrukcjami na ekranie.",
      "securityNotice": "Ze względów bezpieczeństwa i weryfikacji, zdjęcie jest wymagane podczas zameldowania.",
      "privacyInfo": "Szanujemy Twoją prywatność. Twoje dane są bezpiecznie przechowywane i używane tylko do identyfikacji.",
      "closingMessage": "Dziękujemy za współpracę."
    },
    "optional": {
      "title": "Czy chciałbyś zrobić zdjęcie w ramach procesu zameldowania?",
      "instructions": "",
      "securityNotice": "Zrobienie zdjęcia może pomóc usprawnić identyfikację i zwiększyć bezpieczeństwo.",
      "privacyInfo": "Szanujemy Twoją prywatność. Ten krok jest opcjonalny, a Twoje dane będą bezpiecznie obsługiwane.",
      "closingMessage": "Możesz pominąć ten krok, jeśli wolisz."
    },
    "subtitle": "Proszę umieścić się w kadrze i pozostać nieruchomo dla najlepszego rezultatu",
    "button": {
      "cancel": "Anuluj",
      "accept": "Akceptuj",
      "skip": "Pomiń",
      "next": "Następny",
      "recapture": "Zrób zdjęcie ponownie",
      "continue": "Kontynuuj"
    },
    "error": "Wystąpił błąd podczas robienia zdjęcia. Proces zameldowania będzie kontynuowany bez zdjęcia."
  },
  "wayfinding": {
    "title": "Dokąd chciałbyś się udać?"
  },
  "callingMenu": {
    "title": "Menu dzwonienia"
  },
  "bell": {
    "status": {
      "success": {
        "title": "Dzwonek dzwoni",
        "message": "Ktoś zaraz przyjdzie."
      },
      "error": {
        "title": "Coś poszło nie tak",
        "message": "Spróbuj ponownie"
      },
      "loading": {
        "title": "Łączenie...",
        "message": "Proszę czekać"
      }
    }
  },
  "access": {
    "control": {
      "title": "Możesz teraz otworzyć drzwi",
      "subtitle": "Proszę nacisnąć przycisk poniżej.",
      "titleAuto": "Automatyczny dostęp do drzwi",
      "subtitleAuto": "Drzwi otworzą się dla Ciebie automatycznie",
      "openBtn": "Otwórz"
    },
    "status": {
      "success": {
        "title": "Drzwi zostały otwarte",
        "message": ""
      },
      "error": {
        "title": "Coś poszło nie tak",
        "message": "Skontaktuj się z osobą kontaktową, aby otworzyć drzwi."
      },
      "loading": {
        "title": "Otwieranie drzwi...",
        "message": ""
      }
    }
  }
}
